import { render, staticRenderFns } from "./ClientManage.vue?vue&type=template&id=642267d0&scoped=true&"
import script from "./ClientManage.vue?vue&type=script&lang=js&"
export * from "./ClientManage.vue?vue&type=script&lang=js&"
import style0 from "./ClientManage.vue?vue&type=style&index=0&id=642267d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642267d0",
  null
  
)

export default component.exports